import { FeatureBuyTimesBetValue } from '@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController';
import { ISymbolValues } from '../../../core/extra/MiniPayTable';
import { GameData } from './GameData';

export class InitData extends GameData {
    private _featureBuyTimesBetValue: FeatureBuyTimesBetValue[];

    get featureBuyTimesBetValue(): FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    public get isRestoreState(): boolean {
        return this.raw.isRestoreState;
    }

    public get symbolValues(): ISymbolValues {
        return this.raw.symbolValues;
    }

    public get cutIndex(): number[] {
        return this.raw.cutIndex;
    }

    public get gameLevels(): number[] {
        return this.raw.gameLevels;
    }

    setData(data: any) {
        this._featureBuyTimesBetValue = data.featureBuyTimesBetValue;
        super.setData(data);
    }
}
